import Flipbook from "./Components/Flipbook";
import MobileFlipbook from "./Components/MobileFlipbook";
import "./App.css";
import styled from "styled-components";
import { Button, Slide, Tooltip, useMediaQuery } from "@mui/material";
import PageButton from "./Components/PageButton";
import { useEffect, useRef, useState } from "react";
import {
  TransformComponent,
  TransformWrapper,
  useControls,
  useTransformComponent,
} from "react-zoom-pan-pinch";
import { useRecoilState } from "recoil";
import { HandleHelp, openMobileMenu, scaleValue, thumnail } from "./atoms";
import Menu from "./Components/Menu";
import ThumnailViewer from "./Components/ThumnailViewer";
import MobilePageButton from "./Components/MobilePageButton";
import MenuIcon from "@mui/icons-material/Menu";
import MobileMenu from "./Components/MobileMenu";
import Help from "./Components/Help";
import HelpIcon from "@mui/icons-material/Help";

const Wrapper = styled.div`
  width: 100vw;
  /* height: ${(props) => (props.$isMobile ? "85vh" : "100vh")}; */
  height: 100dvh;
  overflow: hidden;
  background-color: #f3f5f6;
`;
const FlipBookBox = styled.div`
  width: ${(props) => (props.$isMobile ? "fit-content" : "100vw")};
  height: ${(props) => (props.$isMobile ? "fit-content" : "100vh")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MenuBox = styled.div`
  width: 100%;
  height: 60px;
  top: 0;
  background-color: white;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
`;

const Controll = styled.div`
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
`;

const MobileMenuButton = styled.div`
  width: 50%;
  position: fixed;
  left: 20px;
  button {
    border: 0 !important;
  }
`;

function App() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [zoomValue, setZoomValue] = useRecoilState(scaleValue);
  const wrapperRef = useRef();
  const [spacePressed, setSpacePressed] = useState(false);
  const [openThumnail, setOpenThumnail] = useRecoilState(thumnail);
  const [isOpenMobileMenu, setIsOpenMobileMenu] =
    useRecoilState(openMobileMenu);
  const [showHelp, setShowHelp] = useRecoilState(HandleHelp);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpenMobileMenu(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize".handleResize);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === "Space") {
        setSpacePressed(true);
      }
    };

    const handleKeyUp = (e) => {
      if (e.code === "Space") {
        setSpacePressed(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const CurrentScale = () => {
    const transformedComponent = useTransformComponent(
      ({ state, instance }) => {
        setZoomValue(state.scale);
      }
    );
    return transformedComponent;
  };
  const handelOpenMobileMenu = () => {
    setIsOpenMobileMenu((prev) => !prev);
  };
  return (
    <Wrapper
      className={spacePressed ? "spacebar-active" : " "}
      $isMobile={isMobile}
      $openThumnail={openThumnail}
    >
      {showHelp && <Help />}
      <TransformWrapper
        minScale={0.3}
        maxScale={2}
        initialScale={zoomValue}
        doubleClick={{ disabled: true }}
        wheel={{ activationKeys: ["Control", "Shift"] }}
        ref={wrapperRef}
        panning={{ disabled: isMobile ? false : !spacePressed }}
      >
        <MenuBox>
          {isMobile ? (
            <div
              style={{
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="https://webfile.mempro.co.kr/image/logo/logo.svg"
                height={25}
              />
              <MobileMenuButton>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handelOpenMobileMenu}
                >
                  <MenuIcon />
                </Button>
              </MobileMenuButton>
              <Tooltip title="help">
                <HelpIcon
                  color="primary"
                  sx={{ cursor: "pointer", position: "fixed", right: 25 }}
                  onClick={() => setShowHelp((prev) => !prev)}
                />
              </Tooltip>
            </div>
          ) : (
            <Menu />
          )}
        </MenuBox>

        <MobileMenu />

        <TransformComponent>
          <CurrentScale />
          <FlipBookBox $isMobile={isMobile}>
            {spacePressed && (
              <div
                style={{
                  backgroundColor: "transaprent",
                  width: "100vw",
                  height: "300vh",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 1000,
                }}
              ></div>
              //스페이스바 눌렀을 때 클릭안되게 방지해주는 div//
            )}
            {isMobile ? <MobileFlipbook /> : <Flipbook />}
          </FlipBookBox>
        </TransformComponent>
      </TransformWrapper>
      <Slide in={openThumnail} mountOnEnter unmountOnExit direction="up">
        <div style={{ display: "flex" }}>
          <ThumnailViewer />
        </div>
      </Slide>
      <Controll>{isMobile ? <MobilePageButton /> : <PageButton />}</Controll>
    </Wrapper>
  );
}

export default App;
